import { useState } from "react";
import { Card, Select } from "antd";
import { FSelect } from "../../commons/formFields/FSelect.jsx";

const { Option } = Select;

const SearchGroups = ({ options, onChange, children: defaultValue }) => {
  const [selected, setSelected] = useState(defaultValue || []);

  return (
    <div>
      <Select
        showSearch
        style={{ minWidth: 400 }}
        placeholder="Search group"
        onChange={(ids) => {
          setSelected(ids);
          onChange(ids);
        }}
        filterOption={(input, option) =>
          option.children.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
        }
        mode="multiple"
        maxTagCount={3}
        value={selected}
      >
        {options.map((option) => (
          <Option key={option.id} value={option.id}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

const ParentGroupSettings = ({
  isParent,
  setIsParent,
  childGroups,
  setChildGroups,
  isGroupSelectionManual,
  groupsToManage,
  groupOptions,
  handleGroupsChange,
}) => {
  return (
    <Card
      title="Parent Group Settings"
      style={{
        marginTop: "24px",
        marginBottom: "24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
        <label htmlFor="defaultCheck2">Is Parent?&nbsp;</label>
        <div className="flex-center">
          <input
            style={{ height: "20px", width: "20px", marginLeft: 10 }}
            type="checkbox"
            className="form-control-input cursor-pointer"
            id="defaultCheck2"
            checked={isParent}
            onChange={(e) => {
              setIsParent(e.target.checked);
              if (!e.target.checked) {
                setChildGroups([]);
              }
            }}
          />
        </div>
      </div>

      {isParent && (
        <div className="form-group">
          <div className="col-md-6">
            <FSelect
              label="Child groups"
              value={isGroupSelectionManual ? "Manual" : childGroups[0]}
              onChange={handleGroupsChange}
              placeholder="--Select Type--"
              dataList={groupsToManage}
              dataKey="key"
              dataValue="type"
              required
            />
          </div>
          {isGroupSelectionManual && (
            <div className="col-md-5">
              <SearchGroups
                options={groupOptions}
                onChange={(children) => {
                  setChildGroups(children);
                }}
              >
                {childGroups}
              </SearchGroups>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default ParentGroupSettings;
